var map = {
	"./h1.jpg": 6684,
	"./h2.jpg": 4379,
	"./h3.jpg": 7918,
	"./h4.jpg": 8805,
	"./h5.jpg": 1544,
	"./h6.jpg": 471,
	"./h7.jpg": 1466,
	"./h8.jpg": 993,
	"./h9.jpg": 2468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7965;